import { EnterpriseProfileOptions } from '@mews-commander/data-access';
import { UnicodeEntity } from '@mews/enums';
import { compactArray } from '@mews/fp';
import { useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Body } from '@optimus-web/core';

export const AdvanceOptionsCell = ({ options }: { options?: EnterpriseProfileOptions | null }) => {
    const localizeText = useLocalizeText();
    const optionsArray = compactArray([
        options?.receiveCustomerMessages ? localizeText({ textKey: TextKey.ReceiveCustomerMessages }) : null,
        options?.resetUsersTwoFactorAuthentication ? localizeText({ textKey: TextKey.ResetTwoFactorShort }) : null,
    ]);

    if (optionsArray.length === 0) {
        return <>{UnicodeEntity.Dash}</>;
    }

    return (
        <Body size="small" ellipsis maxLines={1}>
            {optionsArray.join(', ')}
        </Body>
    );
};
